const RELOAD_KEY = 'sb-update-reload-at';
const RELOAD_WINDOW_MS = 20000;

export function bundleNameFromHtml(html) {
  const match = String(html || '').match(/\/assets\/(main-[A-Za-z0-9_-]+\.js)/);
  return match ? match[1] : '';
}

export function currentBundleName(doc = typeof document !== 'undefined' ? document : null) {
  const nodes = doc?.querySelectorAll?.('script[src]') || [];
  for (const node of nodes) {
    const name = bundleNameFromHtml(node.src || node.getAttribute?.('src') || '');
    if (name) return name;
  }
  return '';
}

export function shouldReloadForBundle(running, hosted) {
  if (!running || !hosted) return false;
  return running !== hosted;
}

export function isStaleBundleError(error) {
  const message = String(error?.message || error || '');
  return /Minified React error #(300|310|321|185)/.test(message)
    || /Rendered fewer hooks than expected/i.test(message)
    || /Rendered more hooks than during the previous render/i.test(message)
    || /Loading chunk [\d]+ failed/i.test(message)
    || /Failed to fetch dynamically imported module/i.test(message)
    || /error loading dynamically imported module/i.test(message)
    || /Importing a module script failed/i.test(message);
}

export function canAutoReload(storage = sessionStorage, now = Date.now()) {
  try {
    const last = Number(storage.getItem(RELOAD_KEY) || 0);
    return !last || now - last > RELOAD_WINDOW_MS;
  } catch (_) {
    return false;
  }
}

export function reloadForUpdate(storage = sessionStorage, reload = () => window.location.reload()) {
  if (!canAutoReload(storage)) return false;
  try {
    storage.setItem(RELOAD_KEY, String(Date.now()));
  } catch (_) {
    return false;
  }
  reload();
  return true;
}

export async function hostedBundleName(fetchImpl = fetch) {
  const response = await fetchImpl(`/index.html?sb=${Date.now()}`, { cache: 'no-store' });
  if (!response?.ok) return '';
  return bundleNameFromHtml(await response.text());
}

export function watchForAppUpdate() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return () => {};
  let pending = false;
  const check = async () => {
    if (pending || document.visibilityState !== 'visible') return;
    pending = true;
    try {
      const hosted = await hostedBundleName();
      if (shouldReloadForBundle(currentBundleName(), hosted)) reloadForUpdate();
    } catch (_) {
      // Keep the open page if the version check cannot reach hosting.
    } finally {
      pending = false;
    }
  };
  const onVisible = () => {
    if (document.visibilityState === 'visible') check();
  };
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('focus', onVisible);
  return () => {
    document.removeEventListener('visibilitychange', onVisible);
    window.removeEventListener('focus', onVisible);
  };
}
